<script setup lang="ts">
defineProps({
  testimony: { type: String, required: false, default: () => '' },
  highlight: { type: String, required: false, default: () => '' },
  author: { type: String, required: false, default: () => '' },
});

function close() {
  document.body.classList.remove('show-testimony-modal');
}
</script>
<template>
  <div class="bg-white fixed w-full h-full testimony-modal overflow-y-auto">
    <div class="content w-11/12 bg-slate-300 min-h-screen block mx-auto">
      <!-- Section -->
       <div class="block mx-auto w-11/12 lg:w-10/12 2xl:w-8/12">
        <!-- Header -->
          <div class="flex justify-between py-8">
            <div></div>
            <button class="text-lg font-bold hover:underline" @click="close">
              {{ $t('BACK')}} X
            </button>
          </div>

          <div class="mt-32">
            <span class="text-2xl font-bold my-4 block">
              {{ author }}
            </span>
            <p class="text-2xl lg:text-5xl highlight text-justify my-8">
              "{{ highlight }}"
            </p>

            <p class="text-lg mt-24 whitespace-break-spaces full-text text-justify pb-10">
              {{ testimony }}
            </p>
          </div>
       </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.testimony-modal {
  z-index: 1000 !important;
  line-height: 1;
  transform: scale(1.1);
  opacity: 0;
  visibility: hidden;

  .full-text {
    line-height: 1.8;
  }

  .highlight {
    line-height: 1.5;
  }
}
</style>